import { render, staticRenderFns } from "./ResultadoBuscaHistorico.vue?vue&type=template&id=06847470"
import script from "./ResultadoBuscaHistorico.vue?vue&type=script&lang=js"
export * from "./ResultadoBuscaHistorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports